<template>
    <div>
      我的资料
      <br>
      开发正在折寿开发ing...
    </div>
</template>

<script>
export default {
  name: 'RecruitMyInfo'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Recruit/RecruitMyInfo.vue